import React from "react";
import "./dashboard.css";

export default function ItemsTable({
  currentPage,
  pages,
  getState,
  findPrincipalName,
  findCategoryName,
  findMetricName,
  findSequenceNo,
  handleEdit,
  handleDelete,
}) {
  const rows = getState();

  return (
    <div
      className={`table-container ${currentPage === 3 ? "scroll-x" : ""} ${
        [0, 1, 2].includes(currentPage) ? "tall-page" : ""
      }`}
    >
      <table className="table table-hover align-middle mb-0 ">
        <thead
          style={{ position: "sticky", top: 0, background: "#fff", zIndex: 6 }}
        >
          <tr>
            <th style={{ width: 60 }}>#</th>
            {currentPage === 1 && (
              <th style={{ width: 160 }}>NCSC Principal</th>
            )}
            {currentPage === 2 && (
              <th style={{ width: 160 }}>NCSC Principal</th>
            )}
            {currentPage === 2 && <th style={{ width: 180 }}>Category</th>}
            {currentPage === 2 && <th style={{ width: 180 }}>Sequence No</th>}
            {currentPage === 3 && (
              <th style={{ width: 160 }}>NCSC Principal</th>
            )}
            {currentPage === 3 && <th style={{ width: 180 }}>Category</th>}
            {currentPage === 3 && <th style={{ width: 180 }}>Metric</th>}
            {currentPage === 3 && <th style={{ width: 140 }}>Sequence No</th>}
            <th className={currentPage === 3 ? "table-title-col" : ""}>
              {pages[currentPage].title}
            </th>
            {currentPage === 3 && (
              <>
                {/* 🔴 Removed Self column */}
                {/* <th style={{ width: 80 }}>Target</th> */}
                <th className="th-notes">Notes</th>
              </>
            )}
            <th style={{ width: 140 }}>Actions</th>
          </tr>
        </thead>

        <tbody>
          {rows.length > 0 ? (
            rows.map((item, idx) => (
              <tr key={item.id}>
                <td>{idx + 1}</td>
                {currentPage === 1 && (
                  <td className="td-small">
                    {findPrincipalName(item.principalId)}
                  </td>
                )}
                {currentPage === 2 && (
                  <td className="td-small">
                    {findPrincipalName(item.principalId)}
                  </td>
                )}
                {currentPage === 2 && (
                  <td className="td-small">
                    {findCategoryName(item.categoryId)}
                  </td>
                )}
                {currentPage === 2 && (
                  <td className="td-small">{findSequenceNo(item.id)}</td>
                )}
                {currentPage === 3 && (
                  <td className="td-small">
                    {findPrincipalName(item.principalId)}
                  </td>
                )}
                {currentPage === 3 && (
                  <td className="td-small">
                    {findCategoryName(item.categoryId)}
                  </td>
                )}
                {currentPage === 3 && (
                  <td className="td-small">{findMetricName(item.metricId)}</td>
                )}
                {currentPage === 3 && (
                  <td className="td-small">{findSequenceNo(item.metricId)}</td>
                )}
                <td
                  title={currentPage === 3 ? item.question : item.text}
                  className="td-title"
                >
                  {currentPage === 3 ? (
                    <span style={{ fontSize: 13, fontWeight: 600 }}>
                      {item.question}
                    </span>
                  ) : (
                    <span>{item.text}</span>
                  )}
                </td>
                {currentPage === 3 && (
                  <>
                    {/* 🔴 Removed Self column */}
                    {/* <td className="td-small">{item.targetScore}</td> */}
                    <td className="td-notes" title={item.notes}>
                      {item.notes}
                    </td>
                  </>
                )}
                <td>
                  <div className="d-flex gap-2">
                    <button
                      className="btn btn-outline-primary btn-sm action-edit"
                      onClick={() => handleEdit(item.id)}
                    >
                      Edit
                    </button>
                    <button
                      className="btn btn-outline-danger btn-sm  action-delete"
                      onClick={() => handleDelete(item.id)}
                    >
                      Delete
                    </button>
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan={currentPage === 3 ? 8 : 4} // 🔴 reduced colSpan since Self removed
                className="text-center text-muted py-4"
              >
                No data added yet
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
